import type { DailyGoalResponse } from "@consistency-circle/shared";

import { DELAY_OPTIONS } from "./constants";
import type { GoalFormState, SlotDraft } from "./types";

export const defaultSlot = (): SlotDraft => ({
  name: "",
  dueTimeLocal: "09:00",
  missGraceMinutes: 15,
  recoveryAction: "",
  notifySelfOnOpen: false,
});

export const defaultForm = (): GoalFormState => ({
  name: "",
  slots: [defaultSlot()],
  notifyCircleId: null,
  notifyThresholdCount: 1,
  notifyThresholdPeriod: "DAY",
  notifyDelayMinutes: 60,
  sharedCircleIds: [],
});

export const createFormFromGoal = (goal: DailyGoalResponse): GoalFormState => ({
  name: goal.name,
  slots: goal.slots.map((slot) => ({
    id: slot.id,
    name: slot.name,
    dueTimeLocal: slot.dueTimeLocal,
    missGraceMinutes: slot.missGraceMinutes,
    recoveryAction: slot.recoveryAction ?? "",
    notifySelfOnOpen: slot.notifySelfOnOpen,
  })),
  notifyCircleId: goal.notifyCircleId,
  notifyThresholdCount: goal.notifyThresholdCount,
  notifyThresholdPeriod: goal.notifyThresholdPeriod,
  notifyDelayMinutes: goal.notifyDelayMinutes,
  sharedCircleIds: goal.sharedCircleIds,
});

export function formatDelay(minutes: number): string {
  const preset = DELAY_OPTIONS.find((option) => option.value === minutes);
  if (preset) return preset.label;
  if (minutes % 60 === 0) return `${minutes / 60}h`;
  return `${minutes} min`;
}

export function notifySummary(goal: DailyGoalResponse, circleName: string): string {
  const period = goal.notifyThresholdPeriod === "WEEK" ? "in a week" : "in a day";
  const misses = goal.notifyThresholdCount === 1 ? "1 miss" : `${goal.notifyThresholdCount} misses`;
  return `${circleName} hears about ${misses} ${period}, ${formatDelay(goal.notifyDelayMinutes)} after the due time`;
}
